import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../services/api";

const EventPage = () => {
  const [events, setEvents] = useState([]); // Stan wydarzeń
  const [error, setError] = useState(null); // Obsługa błędów
  const [filters, setFilters] = useState({
    date: "",
    location: "",
    status: "",
  }); // Filtry

  const navigate = useNavigate();

  // Funkcja do pobierania wydarzeń z backendu
  const fetchEvents = async () => {
    try {
      // Przygotowanie parametrów zapytania
      const params = {};
      if (filters.date) params.date = filters.date;
      if (filters.location) params.location = filters.location;
      if (filters.status) params.status = filters.status;

      const response = await api.get("/Events", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params, // Przekazujemy parametry zapytania
      });

      setEvents(response.data); // Ustawiamy wydarzenia
    } catch (err) {
      console.error(err);
      setError("Failed to fetch events. Please try again later.");
    }
  };

  // Pobieranie wydarzeń przy zmianie filtrów
  useEffect(() => {
    fetchEvents();
  }, [filters]); // Zmieniamy, gdy filtry się zmienią

  // Obsługa zmiany wartości filtrów
  const handleFilterChange = (e) => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value, // Aktualizacja stanu filtrów
    });
  };

  if (error) {
    return <div>{error}</div>; // Wyświetlamy błąd, jeśli wystąpił
  }

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-4">Events</h1>

      {/* Formularz filtrów */}
      <div className="bg-white shadow-md rounded p-4 mb-6">
        <h2 className="text-xl font-semibold mb-4">Filter Events</h2>
        <form className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label htmlFor="filterDate" className="block text-gray-700 mb-2">
              Date:
            </label>
            <input
              type="date"
              id="filterDate"
              name="date"
              value={filters.date}
              onChange={handleFilterChange}
              className="w-full border border-gray-300 rounded px-3 py-2"
            />
          </div>
          <div>
            <label
              htmlFor="filterLocation"
              className="block text-gray-700 mb-2"
            >
              Location:
            </label>
            <input
              type="text"
              id="filterLocation"
              name="location"
              value={filters.location}
              onChange={handleFilterChange}
              placeholder="Enter location"
              className="w-full border border-gray-300 rounded px-3 py-2"
            />
          </div>
          <div>
            <label htmlFor="filterStatus" className="block text-gray-700 mb-2">
              Status:
            </label>
            <select
              id="filterStatus"
              name="status"
              value={filters.status}
              onChange={handleFilterChange}
              className="w-full border border-gray-300 rounded px-3 py-2"
            >
              <option value="">All</option>
              <option value="Planned">Planned</option>
              <option value="InProgress">InProgress</option>
              <option value="Completed">Completed</option>
              <option value="Cancelled">Cancelled</option>
            </select>
          </div>
        </form>
      </div>

      {/* Lista wydarzeń */}
      {events.length === 0 ? (
        <p className="text-gray-700">No events available</p>
      ) : (
        <ul className="space-y-4">
          {events.map((event) => (
            <li key={event.id} className="bg-white shadow-md rounded p-4">
              <h2 className="text-lg font-bold">{event.title}</h2>
              <p className="text-gray-700">
                <strong>Description:</strong>
                {event.description.length > 100
                  ? `${event.description.substring(0, 100)}...`
                  : event.description}
              </p>
              <p>
                <strong>Location:</strong> {event.location}
              </p>
              <p>
                <strong>Date:</strong> {new Date(event.date).toLocaleString()}
              </p>
              <p>
                <strong>Status:</strong> {event.status}
              </p>
              <button
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-2"
                onClick={() => navigate(`/events/${event.id}`)} // Nawigacja do szczegółów
              >
                View Details
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default EventPage;
